<p *ngIf="items?.length > 1" class="item-amount">
  {{ 'FRONTEND.STORE.CONTAINS_NUM_ITEMS' | translate: { itemCount: items.length } }}
</p>
<div class="wrapper">
  <nav *ngIf="items && !hideItemsNav" (swipeleft)="pageNext(slides)" (swiperight)="pagePrev(slides)">
    <div [ngClass]="{ 'hide-arrows': items && items.length < 5 }">
      <span class="prev" (click)="pagePrev(slides)">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </span>
      <span class="next" (click)="pageNext(slides)">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </span>
    </div>
    <ul class="slides" #slides>
      @for (item of items; track $index) {
        <li (click)="onItemSelected($index)">
          <a [ngClass]="{ active: $index === selectedIndex }">
            @if (item | productType) {
              <span class="icon-area">
                <va-icon [iconUrl]="item.iconUrl" [iconName]="item.name" [diameter]="80"></va-icon>
              </span>
              <p>{{ item.name }}</p>
            } @else {
              <span class="icon-area">
                <va-icon [iconUrl]="item.icon" [iconName]="item.title" [diameter]="80"></va-icon>
                <va-icon
                  *ngIf="item.addonId"
                  class="addon-indicator"
                  [iconUrl]="item.productIcon"
                  [iconName]="item.productName"
                  [diameter]="24"
                ></va-icon>
              </span>
              <p>{{ item.title }}</p>
              <span class="requires-text">
                {{ 'FRONTEND.STORE.REQUIRES' | translate }}
              </span>
              <span>{{ item.productName }}</span>
            }
          </a>
        </li>
      }
    </ul>
  </nav>
</div>
